import { Column, Row, Text, TextExternalLink, IconWithBackground } from "@bridgesplit/ui";

import { OnboardingBullet } from "./constants";

export function GuideBullets({
    bullets,
    iconSize = "30px",
    useNumbers = false
}: {
    bullets: OnboardingBullet[];
    iconSize?: string;
    useNumbers?: boolean;
}) {
    const size = parseInt(iconSize);
    const rowSpacing = useNumbers ? 1 : 0;

    return (
        <Column spacing={1}>
            {bullets.map(({ Icon, header, text }, i) => (
                <Column spacing={0.5} key={i}>
                    <Row spacing={rowSpacing}>
                        {useNumbers ? (
                            <IconWithBackground size={size} tagColor="secondary" variant="body2">
                                {i + 1}
                            </IconWithBackground>
                        ) : (
                            <Text sx={{ width: iconSize }} color="secondary">
                                <Icon />
                            </Text>
                        )}

                        <Text>{header}</Text>
                    </Row>
                    <Text sx={{ ml: `calc(${iconSize} + ${rowSpacing * 8}px)` }} color="caption" variant="body2">
                        {text}
                    </Text>
                </Column>
            ))}
        </Column>
    );
}

export function GuideFooter({ docs }: { docs: string }) {
    return (
        <Text sx={{ display: "inline-flex", gap: 0.5 }} color="caption" variant="body2">
            Still have questions?
            <TextExternalLink href={docs}>Read our docs</TextExternalLink>
        </Text>
    );
}
